import { render, staticRenderFns } from "./AutocompleteAggregationItem.vue?vue&type=template&id=4bb1a636"
import script from "./AutocompleteAggregationItem.vue?vue&type=script&lang=js"
export * from "./AutocompleteAggregationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports